import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PalleteColor } from 'nanaykuna-ui-kit/loader';

@Component({
  selector: 'unicon-phone-field',
  templateUrl: './phone-field.component.html',
  styleUrl: '../field.component.scss',
})
export class PhoneFieldComponent implements OnInit, AfterViewInit {
  @Input() placeholder: string = '';
  @Input() value?: string;
  @Input() isActivated!: boolean;
  @Output() result: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('phoneFieldElement') formField!: ElementRef<HTMLFormElement>;
  @ViewChild('formInputField') formInputField!: ElementRef<HTMLInputElement>;
  protected edit: boolean = false;
  protected hovered: boolean = false;
  protected form!: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.setForm();
  }

  ngOnInit(): void {
    this.setInitialValue();
  }

  ngAfterViewInit(): void {
    this.setEditListeners();
  }

  private setInitialValue(): void {
    if (this.value) {
      this.form.controls['input'].setValue(this.value);
    }
  }

  private setForm(): void {
    this.form = this.formBuilder.group({
      input: new FormControl<string>(
        { disabled: true, value: '' },
        Validators.compose([
          Validators.required,
          Validators.pattern(/^519\d{2}\d{3}\d{3}$/),
        ]),
      ),
    });
  }

  private setEditListeners(): void {
    const formComponent: HTMLFormElement = this.formField.nativeElement;
    formComponent?.addEventListener('mouseenter', () => {
      this.hovered = true;
    });
    formComponent?.addEventListener('mouseleave', () => {
      this.hovered = false;
    });
  }

  protected getIconColor(): PalleteColor {
    if (this.form.controls['input'].errors) {
      return 'critical-300';
    }

    if (this.edit) {
      return 'neutrals-900';
    }

    if (this.hovered) {
      return 'neutrals-900';
    }

    return 'neutrals-500';
  }

  protected onEdit(): void {
    this.edit = true;
    this.form.controls['input'].enable();
    this.formInputField.nativeElement.focus();
  }

  protected onSubmit(): void {
    this.edit = false;
    this.form.controls['input'].disable();
    this.result.emit(this.form.controls['input'].value);
  }
}
